var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vinyle"},[_c('div',{staticClass:"cover",style:({ backgroundImage: ("url(" + _vm.coverURL + ")") })}),_c('div',{staticClass:"trou"})])}
var staticRenderFns = []

export { render, staticRenderFns }